// To be used for development/testing purposes

export const students = [
    {
        phone: '9854180207',
        uuid: 'a4d098d4-6274-4d92-bf6f-ea15b190104f',
        type: 'student',
    },
    {
        phone: '8950067821',
        uuid: 'bfd0f57b-20c2-4134-8c85-a3eee073ba96',
        type: 'student',
    },
    {
        phone: '7760157891',
        uuid: 'd90dc299-d0ae-415e-8b5f-4f1ff2f85dba',
        type: 'student',
    },
    {
        phone: '9740462881',
        uuid: '518288ec-939d-4299-80d7-4b32ff864d07',
        type: 'student',
    },
    {
        phone: '8733319024',
        uuid: 'a0e4feb9-430e-447f-96b9-b60eefdd2893',
        type: 'student',
    },
    {
        phone: '9990248111',
        uuid: 'dc6b1b32-45f0-4cfb-8afd-01c28e1d21eb',
        type: 'student',
    },
    {
        phone: '7788561984',
        uuid: '601c42b0-3e6a-418e-838e-bebfe13a8fd4',
        type: 'student',
    },
    {
        phone: '9632495128',
        uuid: '51c0867b-8d34-4b56-9381-cca0b6adf6c5',
        type: 'student',
    },
    {
        phone: '8967789622',
        uuid: '8512e97a-357e-4617-8717-d36e939250b0',
        type: 'student',
    },
    {
        phone: '8885528999',
        uuid: '705aa7b5-d097-4f15-832c-179cd3b0d538',
        type: 'student',
    },
    {
        phone: '9611178431',
        uuid: 'ef126ed2-9d52-41ec-a4be-a66d8129ad28',
        type: 'student',
    },
    {
        phone: '7788552341',
        uuid: 'ac441f6e-528a-4233-a143-9dea5cf9f879',
        type: 'student',
    },
    {
        phone: '9998887722',
        uuid: 'ae43bdd2-9b91-4860-b1aa-006d8226d257',
        type: 'student',
    },
    {
        phone: '9739085777',
        uuid: '6f0edac4-fce9-44f8-a2cb-4a435d7c69f8',
        type: 'student',
    },
    {
        phone: '7779090901',
        uuid: 'fdaea026-c5ad-4b2c-bab7-0d1ead1ec073',
        type: 'student',
    },
    {
        phone: '9830046978',
        uuid: '52213fb5-11da-46da-9149-14b0100744ac',
        type: 'student',
    },
    {
        phone: '6290784360',
        uuid: 'b4a60dd4-f127-4534-b4a6-7cbfd025621c',
        type: 'student',
    },
    {
        phone: '9008585425',
        uuid: 'ced77d46-21a9-4981-a43f-55e024833cbe',
        type: 'student',
    },
    {
        phone: '9007054817',
        uuid: '6b69dc45-ab58-4b85-b2ec-d7870a7970cd',
        type: 'student',
    },
    {
        phone: '9600578094',
        uuid: '9a84a246-3516-4e79-8910-12fa783472c8',
        type: 'student',
    },
    {
        phone: '8146698444',
        uuid: '10b364af-b41e-4ee3-8cab-ab4d9a124504',
        type: 'student',
    },
]

export const teachers = [
    {
        phone: '9600578083',
        uuid: '6c23889e-b528-40c6-83db-783152a09bd3',
        type: 'teacher',
    },
    {
        phone: '9600578093',
        uuid: '1bf9ee05-6ac8-461e-aa02-97a06dc5feb3',
        type: 'teacher',
    },
    {
        phone: '8953317655',
        uuid: '4f6fd106-be9e-4479-a72f-8ccc89c03c77',
        type: 'teacher',
    },
    {
        phone: '8743897732',
        uuid: 'c2e42c19-0bfe-4e6c-ba82-fd7ebf0293b5',
        type: 'teacher',
    },
    {
        phone: '9149171118',
        uuid: 'c9de53b4-b4bf-4945-af54-933f2505095f',
        type: 'teacher',
    },
    /* has quiz on beta */
    {
        phone: '9830992541',
        uuid: '38917109-9e0b-48dd-97ad-f288630183d9',
        type: 'teacher',
    },
]

export const ghosts = [
    {
        phone: '9830101010',
        uuid: '756a66c7-c7e4-4d34-96c1-3d3fd18cf7ec',
        type: 'student',
    },
]

export default []
    .concat(teachers)
    .concat(students)
    .concat(ghosts)
